import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  GenerateProjectPlanRequest,
  GenerateProjectRequest,
  JobInfo,
  ProjectInfo,
  ProjectPlan,
} from '@blaze-shared/api-contracts-domain';
import { XhrService } from '@blaze-shared/platform-data-access';

import { CreatePageRequest } from './chat';

@Injectable({ providedIn: 'root' })
export class AiCreatorService {
  private readonly xhrService = inject(XhrService);

  submitProjectPlanJob(request: GenerateProjectPlanRequest): Observable<JobInfo<ProjectPlan>> {
    return this.xhrService.post('ai/project/plan/v3', request);
  }

  projectCreateJob(request: GenerateProjectRequest): Observable<ProjectInfo[]> {
    return this.xhrService.post('ai/project/create/v3', request);
  }

  /**
   * @deprecated
   * @param request
   */
  createPageJob(request: CreatePageRequest): Observable<JobInfo<null>> {
    return this.xhrService.post<JobInfo<null>>(`ai/page/generate`, request);
  }
}
